import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { get_color, respond, size_fixed_w, typeface } from './assets/styles';
import chevron_down from './assets/images/icn_stroke_chevron_down_grey02.svg';
import chevron_down_green from './assets/images/icn_stroke_chevron_down_hase_green.svg';
import { Header, Footer, FAQ, ServiceOverview, HowToUse} from './view';
import { useRef } from 'react';
import { view } from './utils/url';

const Container = styled('div')`
  padding: 0 26px;
  ${respond(['t'], `
    ${size_fixed_w('972px')}
    margin: 0 auto;
  `)}
  ${respond(['m'], `
    padding: 0 18px;
  `)}
  ${respond(['s'], `
    padding: 0 12px;
  `)}
`;

const Title = styled('div')`
  background-color: ${get_color('grey10')};
  .heading{
    ${typeface('title1')}
    padding: 24px 26px;
    margin: 0 auto 32px;
    ${respond(['t'], `
      ${size_fixed_w('972px')}
    `)}
    ${respond(['m'], `
      ${typeface('title2')}
      padding: 12px 18px;
    `)}
    ${respond(['s'], `
      ${typeface('title3')}
      padding: 12px;
    `)}
  }
`;

const BacktoTop = styled('a')`
  ${typeface('body6')}
  align-items: center;
  color: ${get_color('grey02')};
  display: flex;
  text-decoration: none;
  margin-bottom: 32px;
  width: fit-content;
  &:after{
    content: "";
    background-image: url(${chevron_down});
    transform: rotate(180deg);
    width: 20px;
    height: 20px;
    background-size: cover;
    margin-left: 4px;
  }
  &:hover{
    color: ${get_color('green01')};
    text-decoration: underline;
    &:after{
      background-image: url(${chevron_down_green});
    }
  }
`;

function App() {
  const { t } = useTranslation();
  const headerRef = useRef<HTMLAnchorElement>(null);

  const scrollToTop = (e: React.MouseEvent) =>{
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    setTimeout(function () {
      if(headerRef.current){
        headerRef.current.focus();
      }
    }, 1000)
  }

  return (
      <>
      {view !=='daasc' && <Header ref={headerRef} />}
        <Title><div className="heading" role="heading" aria-level={1}>{t('title')}</div></Title>
        <Container >
          <ServiceOverview />
          <HowToUse />
          <FAQ />
          <BacktoTop href="#" onClick={scrollToTop}>{t('backtoTop')}</BacktoTop>
        </Container>
        <Footer />
      </>
  );
}

export default App;
